/**
 *
 *
 * @example:
 * 		import { IS_DEBUG } from './utils/isdebug';
 *
 * 		this.isDebug = IS_DEBUG();
 * 		console.log('this.isDebug: ' + this.isDebug);
 */
export function IS_DEBUG() {
	let isDebug = false;
	// console.log('window.ING_Art_debugMode: "' + window.ING_Art_debugMode + '"')
	if (window.ING_Art_debugMode !== undefined && window.ING_Art_debugMode === 'true') {
		isDebug = true;
	}
	return isDebug;
};